export const DEFAULT_LANGUAGE = 'de-DE'
